"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomWebsocketMessageQueue = void 0;
var _1 = require(".");
var util_1 = require("../util");
var room_error_code_1 = require("./room-error-code");
// 发送消息完成队列最大长度
var MAX_FINISH_QUEUE_LENGTH = 50;
/**
 * 消息队列管理
 *
 * @class RoomWebsocketMessageQueue
 */
var RoomWebsocketMessageQueue = /** @class */ (function () {
    function RoomWebsocketMessageQueue(dependency) {
        this.messageWaittingQueue = [];
        this.messageFinishQueue = [];
        this.messageSenderDependency = dependency;
    }
    RoomWebsocketMessageQueue.prototype.dispose = function () {
        this.messageWaittingQueue = [];
        this.messageFinishQueue = [];
    };
    RoomWebsocketMessageQueue.prototype.messageCount = function () {
        return this.messageWaittingQueue.length;
    };
    /**
     * 对已在队列的消息进行去重，seq和cmd都相等
     *
     * @param {IRoomSendMessagePacket} message
     * @returns {boolean}
     */
    RoomWebsocketMessageQueue.prototype.messageAlreadyExist = function (message) {
        var msg = this.getMessageByTaskId(message.taskId);
        if ((msg === null || msg === void 0 ? void 0 : msg.cmd) === message.cmd) {
            return true;
        }
        return false;
    };
    RoomWebsocketMessageQueue.prototype.getMessageByTaskId = function (taskId) {
        return this.messageWaittingQueue.find(function (message) { return message.taskId === taskId; });
    };
    RoomWebsocketMessageQueue.prototype.getFinishedMessageByTaskId = function (taskId) {
        return this.messageFinishQueue.find(function (message) { return message.taskId === taskId; });
    };
    RoomWebsocketMessageQueue.prototype.readyToSendMessage = function () {
        if (this.messageWaittingQueue.length === 0) {
            util_1.ConnectionLog.info('readyToSendMessage: empty messageQueue');
            return false;
        }
        var sendingMessage = this.messageWaittingQueue.find(function (message) { return message.state === _1.MessageState.SENDING; });
        if (sendingMessage) {
            util_1.ConnectionLog.info("readyToSendMessage: message is sending, taskId:" + sendingMessage.taskId + ", cmd:" + sendingMessage.cmd);
            return false;
        }
        return true;
    };
    RoomWebsocketMessageQueue.prototype.addWaittingMessage = function (newMsg) {
        this.messageWaittingQueue.push(newMsg);
    };
    RoomWebsocketMessageQueue.prototype.addFinishMessage = function (message, targetIdx) {
        if (targetIdx === void 0) { targetIdx = -1; }
        this.removeMessageFromQueue(message, targetIdx);
        this.messageFinishQueue.push(message);
    };
    RoomWebsocketMessageQueue.prototype.removeMessageFromQueue = function (message, targetIdx) {
        if (targetIdx === void 0) { targetIdx = -1; }
        var idx = targetIdx >= 0 && targetIdx < this.messageWaittingQueue.length
            ? targetIdx : this.getIndexOfMessage(message);
        this.messageWaittingQueue.splice(idx, 1);
    };
    /**
     * @param shutDown 是否 shutdown
     */
    RoomWebsocketMessageQueue.prototype.handleMessageQueueByRoomClose = function (shutDown) {
        var idx = 0;
        while (idx < this.messageWaittingQueue.length) {
            var msg = this.messageWaittingQueue[idx];
            this.handleMessageByRoomClose(msg, shutDown);
            idx += 1;
        }
    };
    RoomWebsocketMessageQueue.prototype.handleMessageByRoomClose = function (msg, shutDown) {
        this.messageSenderDependency.doErrorCallback(msg, {
            errCode: shutDown ? room_error_code_1.RoomErrorCode.ROOM_SHUTDOWN : room_error_code_1.RoomErrorCode.ROOM_CLOSE,
            errMsg: "room " + (shutDown ? 'shutDown' : 'close'),
        });
    };
    RoomWebsocketMessageQueue.prototype.handleMsgBySocketDisconnect = function () {
        // 达到次数上限的，失败回调， 没有 改为waiting中
        var index = 0;
        while (index < this.messageWaittingQueue.length) {
            var msg = this.messageWaittingQueue[index];
            if (msg.retryCount >= msg.maxRetryCount) {
                this.handleRetryCountLimitedMessageBySocketDisconnect(msg);
                this.removeMessageFromQueue(msg, index);
                continue;
            }
            else {
                this.handleMesageBySocketDisconnect(msg);
                index += 1;
            }
        }
    };
    RoomWebsocketMessageQueue.prototype.getFirstWaittingMessage = function () {
        return this.messageWaittingQueue.find(function (waittingMessage) { return waittingMessage.state === _1.MessageState.WAITING; });
    };
    RoomWebsocketMessageQueue.prototype.processMessageQueue = function () {
        // 查询消息队列
        var needToSendNextMsg = false;
        var haveMsgSending = false;
        var haveMsgWaiting = false;
        var index = 0;
        while (index < this.messageWaittingQueue.length) {
            var msg = this.messageWaittingQueue[index];
            if (this.sendingMsgIsTimeout(msg)) {
                // 处理中，且已经超时
                needToSendNextMsg = true;
                if (msg.retryCount < msg.maxRetryCount) {
                    // 继续重试
                    this.retryMessageByTimeout(msg);
                    index += 1;
                }
                else {
                    this.handleRetryCountLimitedMessageByTimeout(msg);
                }
            }
            else {
                haveMsgSending = msg.state === _1.MessageState.SENDING;
                haveMsgWaiting = msg.state === _1.MessageState.WAITING;
                index += 1;
            }
        }
        this.clearFinishQueueIfNeed();
        if (!haveMsgSending && haveMsgWaiting) {
            needToSendNextMsg = true;
        }
        return needToSendNextMsg;
    };
    RoomWebsocketMessageQueue.prototype.cancelMessage = function (seq) {
        var idx = 0;
        while (idx < this.messageWaittingQueue.length) {
            var msg = this.messageWaittingQueue[idx];
            if (msg.taskId === seq) {
                util_1.ConnectionLog.info("cancelMessage: seq = " + seq);
                this.addFinishMessage(msg);
                return msg;
            }
            idx += 1;
        }
        return undefined;
    };
    RoomWebsocketMessageQueue.prototype.clearFinishQueueIfNeed = function () {
        if (this.messageFinishQueue.length > MAX_FINISH_QUEUE_LENGTH) {
            this.messageFinishQueue.splice(0, this.messageFinishQueue.length - MAX_FINISH_QUEUE_LENGTH);
        }
    };
    RoomWebsocketMessageQueue.prototype.sendingMsgIsTimeout = function (msg) {
        var nowTime = _1.RoomUtil.getCurrentTime();
        return (msg.state === _1.MessageState.SENDING || msg.state === _1.MessageState.WAIT_ACCEPT)
            && nowTime > msg.lastSendTime && nowTime - msg.lastSendTime > msg.timeout;
    };
    RoomWebsocketMessageQueue.prototype.handleRetryCountLimitedMessageBySocketDisconnect = function (msg) {
        if (!this.messageIsSendingOrWaitAccept(msg))
            return;
        // 达到重试次数上限，失败
        this.messageSenderDependency.doErrorCallback(msg, {
            errCode: room_error_code_1.RoomErrorCode.ROOM_DISCONNECT,
            errMsg: 'room disconnect',
        });
    };
    RoomWebsocketMessageQueue.prototype.handleMesageBySocketDisconnect = function (msg) {
        if (!this.messageIsSendingOrWaitAccept(msg))
            return;
        // 转成waiting，等待重试
        msg.state = _1.MessageState.WAITING;
    };
    RoomWebsocketMessageQueue.prototype.messageIsSendingOrWaitAccept = function (msg) {
        return msg.state === _1.MessageState.SENDING || msg.state === _1.MessageState.WAIT_ACCEPT;
    };
    RoomWebsocketMessageQueue.prototype.handleRetryCountLimitedMessageByTimeout = function (msg) {
        // 超过重传次数、出错
        util_1.ConnectionLog.warn("send message timeout, taskId = " + msg.taskId + ", cmd = " + msg.cmd + ".");
        // 连续发送超时重新发送前重置
        msg.retryCount = 0;
        // 连续发送超时后延迟重新打开房间，创建新ws连接
        this.messageSenderDependency.closeAndDelayReopen({
            reason: 'websocket send message timeout.',
            errCode: _1.RoomWebsocketErrorCode.SOCKET_SEND_MESSAGE_TIMEOUT,
            shutDown: false,
        }, 0);
    };
    RoomWebsocketMessageQueue.prototype.retryMessageByTimeout = function (msg) {
        util_1.ConnectionLog.warn("send message timeout, try again, taskId = " + msg.taskId + ",\n        cmd = " + msg.cmd + ", retryCount = " + msg.retryCount + ", maxRetryCount = " + msg.maxRetryCount + ", state = " + msg.state);
        msg.state = _1.MessageState.WAITING;
    };
    RoomWebsocketMessageQueue.prototype.getIndexOfMessage = function (message) {
        return this.messageWaittingQueue.findIndex(function (waittingMessage) { return waittingMessage.taskId === message.taskId; });
    };
    return RoomWebsocketMessageQueue;
}());
exports.RoomWebsocketMessageQueue = RoomWebsocketMessageQueue;
